import {
    EmailLibrary,
    TaskTypes,
    ScriptManagement,
    TextMessageLibrary,
    CallTags
} from "pages";
import RestrictedView from "shared/RestrictedView";
import { PRODUCT_PERMISSIONS, USER_PERMISSIONS } from "dyl-components";

import React from 'react';
import { Route } from 'react-router-dom';

export const LIBRARY_ROUTES = [
    <Route index path='text-templates' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.LIBRARY_VIEW}><TextMessageLibrary /></RestrictedView>} />,
    <Route path='email-templates' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.LIBRARY_VIEW}><EmailLibrary /></RestrictedView>} />,
    <Route path='dialer-scripts' element={<RestrictedView type='restricted' productPermission={PRODUCT_PERMISSIONS.SETTINGS_DIALER_SCRIPTS} userPermission={USER_PERMISSIONS.LIBRARY_VIEW}><ScriptManagement /></RestrictedView>} />,
    <Route path='task-types' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.LIBRARY_VIEW}><TaskTypes /></RestrictedView>} />,
    <Route path='call-tags' element={<RestrictedView type="restricted" productPermission={PRODUCT_PERMISSIONS.SETTINGS_CALL_TAGS} userPermission={USER_PERMISSIONS.LIBRARY_VIEW}><CallTags /></RestrictedView>} />
];
